import { styled } from 'stitches.config'

export const ReviewCardRoot = styled('div', {
  height: 'min-content',
  width: '328px',
  borderRadius: '$6',
  py: '$4',
  px: '$6',
  display: 'flex',
  justifyContent: 'center',

  '@bp2': {
    width: '378px',
  },

  variants: {
    color: {
      white: {
        backgroundColor: '$accent-white',
      },
      secondary: {
        backgroundColor: '$secondary-500',
      },
      neutral: {
        backgroundColor: '$accent-account-submenu',
      },
    },
  },

  defaultVariants: {
    color: 'white',
  },
})
